import React, {useState } from "react";

const AttachementComp = (props) => {
    const [content, setContent] = useState(props.data.Attachments[0]);
    const downloadAttachment = async(e) => {
        e.preventDefault();
        if(!content.AttachmentId){ return; }
        props.fnDownLoadAttachement(content)
    }

    const renderContent = () => {
        if (content.Status === "APPROVED") {
            return <a href={content.AttachmentName} onClick={downloadAttachment}
                onKeyPress={downloadAttachment }>{content.AttachmentName}</a>
        }
        return this.props.content.AttachmentName;
    }

    return (
        <React.Fragment>
            {renderContent()}
        </React.Fragment>
    );
};

export default AttachementComp;
